export const environment = {
  production: false,
  apiUrl: 'https://api-staging.routini.at',
  keycloak: {
    url: 'https://auth-staging.routini.at',
    realm: 'routini-passenger',
    clientId: 'passenger-web-app',
    urlPattern: /^(https:\/\/api-staging.routini.at)(\/.*)?$/i,
    sessionTimeout: 300000,
    authUrl:
      'https://auth-staging.routini.at/realms/routini-passenger/protocol/openid-connect/auth?response_type=code&client_id=passenger-web-app&redirect_uri=https://fahrgast-staging.routini.at/home',
  },
  connectRedirectUri: 'https://fahrgast-staging.routini.at/connectAccount',
};
